import React, { useState } from 'react';
import { ThumbnailLoading } from '../../../../../shared/src/components/ThumbnailLoading';
import './WinnersDesktopContainer.css';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { useSelector } from 'react-redux';
import { WinnerThumbnail } from '../WinnerThumbnail';
import { useWinnersRotationDesktop } from '../hooks/use-winners-rotation-desktop.hook';

export const WinnersDesktopContainer = ({
    className = '',
    gridPosition = 0,
}) => {
    const [currentWinner, setCurrentWinner] = useState(null);
    const { loadGame } = useAsgActions();
    const winners = useSelector((state) => state.winners.list);

    // winners rotation
    useWinnersRotationDesktop(
        winners,
        gridPosition,
        setCurrentWinner,
        [winners],
    );

    return (
        <div className={`${className} asg-desktop-winners`}>
            {!currentWinner && <ThumbnailLoading iconName="winner" />}
            {currentWinner && <WinnerThumbnail
                winner={currentWinner}
                playNowHandler={loadGame}
            />}
        </div>
    );
};
